<template>
    <el-container>
        <el-header>
            <commonheader :isNavShow='true'></commonheader>
        </el-header>

        <el-container class="el-container-master">
            <el-aside style="width:220px">
                <leftMenu></leftMenu>
            </el-aside>
            <el-main>
                <section class="flex">
                    <exit></exit>
                    <div class="content requestVoiceCont">
                        <el-form :model="formValue" ref="formValue" :rules="rules" label-width="100px" class="">

                            <el-row>
                                <el-col :span="8" :offset='1'>
                                    <el-form-item label="订单编号" prop="orderNumber">
                                        <!-- <el-input v-model="formValue.orderNumber" placeholder="请输入订单编号" :disabled="this.$route.query.type == 'seeInvoice'"></el-input> -->
                                        <el-input v-model="formValue.orderNumber" placeholder="请输入订单编号" disabled>
                                        </el-input>
                                    </el-form-item>
                                </el-col>

                                <el-col :span="8" :offset='4'>
                                    <el-form-item label="联系电话" prop="contactPhone">
                                        <el-input v-model="formValue.contactPhone" placeholder="请输入联系电话"
                                            :disabled="this.$route.query.type == 'seeInvoice'" maxlength="11">
                                        </el-input>
                                    </el-form-item>
                                </el-col>

                            </el-row>
                            <el-row>
                                <el-col :span="8" :offset='1'>
                                    <el-form-item label="发票类型" prop="invoiceType">
                                        <el-select v-model="formValue.invoiceType" placeholder="请选择"
                                            :disabled="this.$route.query.type == 'seeInvoice'">
                                            <el-option v-for="item in options" :key="item.value" :label="item.label"
                                                :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>

                                <el-col :span="8" :offset='4'>
                                    <el-form-item label="邮箱" prop="email">
                                        <el-input v-model="formValue.email" placeholder="请输入邮箱"
                                            :disabled="this.$route.query.type == 'seeInvoice'"></el-input>
                                    </el-form-item>
                                </el-col>

                            </el-row>

                            <el-row>
                                <!-- <el-col :span="8" :offset='1'>
                                    <el-form-item label="发票明细" prop="invoice_detail">
                                        <el-input v-model="formValue.invoice_detail" placeholder="请输入发票明细"
                                            :disabled="this.$route.query.type == 'seeInvoice'"></el-input>
                                    </el-form-item>
                                </el-col> -->
                                <el-col :span="8" :offset='1'>
                                    <el-form-item label="抬头类型" prop="invoiceTitleType">
                                        <el-select v-model="formValue.invoiceTitleType" placeholder="请选择"
                                            @change="currentSel" :disabled="this.$route.query.type == 'seeInvoice'">
                                            <el-option label="企业" value="企业"></el-option>
                                            <el-option label="个人" value="个人"></el-option>
                                        </el-select>
                                        <!-- <el-input v-model="formValue.invoiceTitleType" placeholder="请输入抬头类型"></el-input> -->
                                    </el-form-item>
                                </el-col>


                                <el-col :span="8" :offset='4' v-if="formValue.invoiceTitleType == '企业'">
                                    <el-form-item label="税号" prop="taxNumber">
                                        <el-input v-model="formValue.taxNumber" placeholder="请输入税号"
                                            :disabled="this.$route.query.type == 'seeInvoice'"></el-input>
                                    </el-form-item>
                                </el-col>

                                <el-col :span="8" :offset='4'  v-if="formValue.invoiceTitleType == '个人'">
                                    <el-form-item label="备注" prop="remark">
                                        <el-input v-model="formValue.remark" placeholder="显示在发票的备注栏上"
                                            :disabled="this.$route.query.type == 'seeInvoice'"></el-input>
                                    </el-form-item>
                                </el-col>

                            </el-row>

                            <el-row>


                            </el-row>

                            <el-row v-if="formValue.invoiceTitleType == '企业'">
                                <el-col :span="8" :offset='1'>
                                    <el-form-item label="发票抬头" prop="invoiceTitle">
                                        <el-input v-model="formValue.invoiceTitle" placeholder="请输入发票抬头"
                                            :disabled="this.$route.query.type == 'seeInvoice'"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8" :offset='4'>
                                    <el-form-item label="备注" prop="remark">
                                        <el-input v-model="formValue.remark" placeholder="显示在发票的备注栏上"
                                            :disabled="this.$route.query.type == 'seeInvoice'"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>

                            </el-row>

                            <div class="signUpNowBtn blueGradient submitRequestInvoice" @click="submitForm()"
                                v-if="this.$route.query.type == 'requestInvoice'">提交</div>
                        </el-form>

                    </div>
                </section>
            </el-main>
        </el-container>
    </el-container>

</template>
<script>
import commonheader from "../common/commonHeader.vue"; //头部组件
import leftMenu from "../common/leftMenu.vue"; //头部组件
import exit from "../common/exit.vue"; //头部组件
export default {
    name: 'studentsNote',
    components: {
        commonheader,
        leftMenu,
        exit
    },


    data () {
        return {
            options: [
                {
                    value: '增值税电子普通发票',
                    label: '增值税电子普通发票'
                },


            ],

            formValue: {
                invoiceType: '增值税电子普通发票',
                invoiceTitleType: '企业',
            },
            value: '',

            rules: {
                orderNumber: [
                    { required: true, message: '请输入订单编号', trigger: 'blur' },
                    { pattern: /^(?:-?\d+|-?\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/, message: '订单号只能为数字' }
                ],
                taxNumber: [
                    { required: true, message: '请输入税号', trigger: 'blur' },
                    // { pattern: /^(?:-?\d+|-?\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/, message: '请输入正确的税号' }
                ],

                invoiceType: [
                    { required: true, message: '请输入发票类型', trigger: 'blur' },
                ],

                contactPhone: [
                    { required: true, message: '请输入联系电话' },
                    { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号' }


                ],
                invoice_detail: [
                    // { required: true, message: '请输入发票明细', trigger: 'blur' },
                ],


                email: [
                    { required: true, message: '请输入邮箱', trigger: 'blur' },
                    { pattern: /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/, message: '请输入正确的邮箱' }

                ],

                invoiceTitleType: [
                    { required: true, message: '请输入抬头类型', trigger: 'blur' },
                ],


                invoiceTitle: [
                    { required: true, message: '请输入发票抬头', trigger: 'blur' },
                ],

            }

        }
    },
    mounted: function () {
        document.getElementsByTagName("html")[0].className = "my-page";
        console.log('申请还是查看电子发票类型==', this.$route.query.type)
        // this.formValue.orderNumber = this.$route.query.orderId
        this.$set(this.formValue, 'orderNumber', this.$route.query.orderId)


    },
    methods: {
        submitForm () {

            this.$refs['formValue'].validate((valid) => {

                if (valid) {


                    //let requestInvoiceParams = this.formValue;
                    console.log('通过申请电子发票验证valid========', this.formValue)
                    this.submitRequstInvoiceInfor(this.formValue)



                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },

        currentSel (selVal) {
            this.formValue.invoiceTitleType = selVal;
        },



        submitRequstInvoiceInfor (formValue) {

            // invoiceType: "普通发票"
            // invoiceTitleType: "企业"
            // orderNumber: "123456"
            // invoice_detail: "234567"
            // invoiceTitle: "234567"
            // contactPhone: "15031533195"
            // email: "123@163.com"
            // taxNumber: "1234"

            // order_id订单id
            // type开票类型1个人2企业
            // invoice_title抬头
            // tax_number税号
            // invoice_detail开票明细
            // phone手机号
            // email邮箱
            let submitRequstInvoiceInforParams = {
                order_id: formValue.orderNumber,
                type: formValue.invoiceTitleType == '个人' ? 1 : 2,
                invoice_title: formValue.invoiceTitle,
                tax_number: formValue.taxNumber,
                phone: formValue.contactPhone,
                email: formValue.email,
                remark:formValue.remark,
                invoice_detail:''//formValue.invoice_detail
            }
            this.$store.dispatch('submitInvoiceInforApi', submitRequstInvoiceInforParams)
                .then((res) => {
                    if (res.code == 200) {
                        this.$message('提交成功，开票审核中');
                        setTimeout(() => {
                            this.$router.go(-1);
                        }, 2000)


                    } else {


                    }

                    //console.log(this.associationNewsListData)

                }).catch(error => {
                    console.log('catch====', error)
                })

        }












    },
}
</script>

<style lang="stylus" scoped>
@media (min-width: 1399px)
    .el-container-master
        width 1400px
        margin auto
.el-aside
    background #fff
.el-main
    padding 0
    background #fff
.content
    padding 47px 57px 0 86px
    flex 1
    border-top 10px solid #F8F8F8
    border-left 10px solid #F8F8F8
    .title
        margin 25px 0 19px
        font-size 20px
        color #0173FF
        border-left 2px solid #0173FF
        padding-left 10px
    p
        font-size 16px
        color #333
        line-height 30px
.signUpNowBtn
    height 42px
    line-height 42px
    text-align center
    color #fff
    width 290px
    margin 50px auto 0
    border-radius 4px
    cursor pointer
    letter-spacing 2px
.submitRequestInvoice
    margin-top 150px
.el-select
    width 242px
</style>
<style lang="stylus">
.requestVoiceCont input
    width 242px
</style>



// WEBPACK FOOTER //
// src/components/my/requestInvoice.vue